var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderRejectReason
    ? _c(
        "div",
        { staticClass: "order-reject-reason" },
        [
          _c("div", { staticClass: "order-reject-reason-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _vm._l(_vm.orderRejectReason.split("###"), function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "order-reject-reason-list" },
              [
                _c("div", { staticClass: "seq" }, [
                  _vm._v(_vm._s(index + 1) + ".")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [_vm._v(_vm._s(item))])
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5062e806", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5062e806","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/order/order-reject-reason.vue
// module id = Z3kZ
// module chunks = 2